export const breakpoints = {
  xs: "22.5rem", // 360px
  sm: "30rem", // 480px
  md: "48rem", // 768px
  lg: "60rem", // 960px
  xl: "75rem", // 1200px
  "2xl": "90rem", // 1440px
  "3xl": "100rem", // 1600px
  "4xl": "120rem", // 1920px
};
